import { useContext, useEffect, useState } from "react";
import { ResourceMoniteringContext } from "../../resourcePlanner/resourceMonitoring/ResourceContext";

export const useFilteredScopes = (scopes) => {
  const [filteredScopes, setFilteredScopes] = useState(scopes);
  const { filterStartDate, filterEndDate, filterStatus } = useContext(
    ResourceMoniteringContext
  );
  useEffect(() => {
    const filterScopes = () => {
      const hasStartDateFilter =
        filterStartDate !== null && filterStartDate !== "";
      const hasEndDateFilter = filterEndDate !== null && filterEndDate !== "";
      const hasStatusFilter =
        Array.isArray(filterStatus) && filterStatus.length > 0;

      if (!hasStartDateFilter && !hasEndDateFilter && !hasStatusFilter) {
        setFilteredScopes(scopes);
        return;
      }

      const filtered = scopes
        .map((scope) => ({
          ...scope,
          tasks: scope.tasks.filter((task) => {
            const taskStart = new Date(task.startDate);
            const taskEnd = new Date(task.endDate);

            let meetsStartDateCriteria = true;
            let meetsEndDateCriteria = true;
            let meetsStatusCriteria = true;

            if (hasStartDateFilter) {
              const filterStart = new Date(filterStartDate);
              meetsStartDateCriteria = taskStart >= filterStart;
            }

            if (hasEndDateFilter) {
              const filterEnd = new Date(filterEndDate);
              meetsEndDateCriteria = taskEnd <= filterEnd;
            }

            if (hasStatusFilter) {
              meetsStatusCriteria = filterStatus.includes(
                task.status.toString()
              );
            }

            return (
              meetsStartDateCriteria &&
              meetsEndDateCriteria &&
              meetsStatusCriteria
            );
          }),
        }))
        .filter((scope) => {
          return scope.tasks.length > 0 || scope.tasks.length === 0;
        });

      setFilteredScopes(filtered);
    };

    filterScopes();
  }, [scopes, filterStartDate, filterEndDate, filterStatus]);

  return { filteredScopes };
};
